import { useUserContext } from '~/core/context'
import { useNango } from '~/plugins/nango/client'
import { NangoClientType } from '../../authentication/client'
import { ProviderClient } from '../../providers/abstract/provider.client'

export const useStrategyNango = () => {
  const { session } = useUserContext()

  const nango = useNango()

  const start = async (provider: ProviderClient) => {
    const authentication = provider.authentication as NangoClientType

    const response = await nango.auth(
      authentication.providerConfigKey,
      session.user.id,
    )

    return response
  }

  return {
    start,
  }
}
